export default __webpack_public_path__ + "static/media/jquery-logo.d262b2f2.png";